import { React, useState } from 'react';
import SearchGlass from '../icons/Search-Glass.svg';
import { Link } from 'react-router-dom';

export default function SearchBar(s) {
  const [name, setName] = useState('');
  const [nameSubmitted, changeStatus] = useState(false);

  function handleSubmit(event) {
    console.log(name);
    event.preventDefault();
    changeStatus(true);
    window.location.href = `/artist?name=${name}`;
  }

  function handleChange(event) {
    console.log(event.target.value);
    setName(event.target.value);
  }
  return (
    <form className="searchBar" onSubmit={handleSubmit}>
      <input placeholder="" onChange={handleChange} type="text" />
      <input
        type="image"
        value="submit"
        src={SearchGlass}
        className="searchIcon"
        alt="searchIcon"
      ></input>
    </form>
  );
}
